import { Link, useLocation } from "react-router-dom";
import FittinMark from "@/components/fittin/FittinMark";

export default function Footer() {
  const { pathname } = useLocation();
  // Same-page hash links: scroll even when the URL hash is already set.
  const onHash = (id) => (e) => {
    if (pathname !== "/") return;
    const el = document.querySelector(id);
    if (!el) return;
    e.preventDefault();
    window.history.replaceState(null, "", `/${id}`);
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  return (
    <footer
      id="footer"
      data-testid="site-footer"
      className="relative py-16 border-t border-black/10 mt-10"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10 grid grid-cols-2 md:grid-cols-5 gap-10">
        <div className="col-span-2">
          <div className="flex items-center gap-2">
            <FittinMark size={24} />
            <span className="text-[17px] font-medium tracking-tight">Fittin</span>
          </div>
          <p className="mt-3 text-[13px] text-neutral-500 max-w-xs">
            The invisible sizing layer for fashion e-commerce.
          </p>
        </div>

        <div>
          <div className="text-[11px] uppercase tracking-[0.22em] text-neutral-500 mb-3">
            Product
          </div>
          <ul className="space-y-2 text-[13px] text-neutral-700">
            <li><Link to="/#create-fitkey" onClick={onHash("#create-fitkey")} data-testid="footer-create-fitkey" className="hover:text-[#0A0A0A]">Create your FitKey</Link></li>
            <li><Link to="/signin" data-testid="footer-signin" className="hover:text-[#0A0A0A]">Sign in with FitKey</Link></li>
            <li><Link to="/#returns" onClick={onHash("#returns")} data-testid="footer-returns" className="hover:text-[#0A0A0A]">Returns</Link></li>
            <li><a href="#integration" data-testid="footer-integration" className="hover:text-[#0A0A0A]">Integration</a></li>
            <li><a href="#philosophy" data-testid="footer-philosophy" className="hover:text-[#0A0A0A]">Philosophy</a></li>
          </ul>
        </div>

        <div>
          <div className="text-[11px] uppercase tracking-[0.22em] text-neutral-500 mb-3">
            Company
          </div>
          <ul className="space-y-2 text-[13px] text-neutral-700">
            <li><Link to="/companies#contact" data-testid="footer-contact" className="hover:text-[#0A0A0A]">Contact</Link></li>
            <li><Link to="/companies" data-testid="footer-companies" className="hover:text-[#0A0A0A]">For companies</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-[11px] uppercase tracking-[0.22em] text-neutral-500 mb-3">
            Legal
          </div>
          <ul className="space-y-2 text-[13px] text-neutral-700">
            <li>
              <Link to="/legal/privacy" data-testid="footer-legal-privacy" className="hover:text-[#0A0A0A]">
                Privacy
              </Link>
            </li>
            <li>
              <Link to="/legal/imprint" data-testid="footer-legal-imprint" className="hover:text-[#0A0A0A]">
                Imprint
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-6 md:px-10 mt-14 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-[12px] text-neutral-500">
        <div>© 2026 Fittin. All rights reserved.</div>
        <div>Made for operators. Built for calm.</div>
      </div>
    </footer>
  );
}
